// extracted by mini-css-extract-plugin
module.exports = {"bar":"style_bar__VE-ar","element":"style_element__2vodi"};